import React, {Fragment, useEffect, useState} from "react";
import Select from "react-select";
import select_styles from "../../../../../../../../layouts/elements";
import {useTranslation} from "react-i18next";

const INITIAL_STATE = [{value: null, label: "-----"}]

const OthersInputs = ({index, othersMusicians, otherMusiciansList, dispatch}) => {
    const { t } = useTranslation();

    const options_users_list = otherMusiciansList.length > 0
        ? [{"value": "0000", "label": "-- clear --"}, ...otherMusiciansList]
        : [{"value": "0000", "label": "-- clear --"}];

    const otherHandle = (val, opt) => {
        let dataSet = {}
        if (opt === 'musician') {
            dataSet = {...othersMusicians, musician: val, instrument: INITIAL_STATE[0]}
        } else {
            dataSet = {...othersMusicians, instrument: val}
        }
        dispatch({type: "SET_OTHERS_MUSICIANS", dataSet: dataSet, position: index})
    }

    return (<>
        <div key={`${index}-musician`} className="px-2">
            <p className="mb-0">{t("project.lineup.other_musicians_person")}:</p>
            <div>
                <Select
                    key={`muzyk-key`}
                    placeholder={"Wybierz muzyka" + " *"}
                    closeMenuOnSelect={true}
                    isMulti={false}
                    options={options_users_list}
                    value={othersMusicians && othersMusicians.musician ? othersMusicians.musician : INITIAL_STATE[0]}
                    onChange={val => otherHandle(val, "musician")}
                    className="addiMusField"
                    styles={select_styles}
                    unstyled
                />
            </div>

            <p className="mb-0">{t("project.lineup.other_musicians_person_instr")}:</p>
            <div>
                <Select
                    key={`instrument-key`}
                    placeholder={"Wybierz instrument" + " *"}
                    closeMenuOnSelect={true}
                    isMulti={false}
                    options={othersMusicians && othersMusicians.musician ? othersMusicians.musician.instruments : INITIAL_STATE}
                    value={othersMusicians && othersMusicians.instrument ? othersMusicians.instrument : INITIAL_STATE[0]}
                    onChange={val => otherHandle(val, "instrument")}
                    className="addiMusField"
                    styles={select_styles}
                    unstyled
                />
            </div>
        </div>
    </>)
}


const OthersList = ({others, othersMusicians, dispatch, otherMusiciansList}) => {
    const { t } = useTranslation();

    const dynamicMusicianFields = Array.from({length: +others}, (_, index) => (
       <OthersInputs
           index={index + 1}
           otherMusiciansList={otherMusiciansList}
           othersMusicians={othersMusicians[index + 1]}
           dispatch={dispatch}
       />
    ))

    return (<>
        {others && +others.length > 0 && (<>
            {dynamicMusicianFields.reduce((result, field, index) => {
                if (index % 2 === 0) {
                    result.push(
                        <div className="col-sm-6 col-md-4 px-0" key={`group-${index}`}>
                            <div style={{display: 'flex', flexWrap: 'wrap'}}>
                                <div key={`${index}-musician`} style={{width: '50%', paddingLeft: '10px', paddingRight: '10px'}}>
                                    <p style={{fontWeight: 'bold'}}>{t("project.lineup.person_title") + " " + (index + 1)}</p>
                                    {field}
                                </div>
                                {dynamicMusicianFields[index + 1] && ( // Sprawdzamy, czy istnieje następny element
                                    <div key={`${index + 1}-musician`} style={{width: '50%', paddingLeft: '10px', paddingRight: '10px'}}>
                                        <p style={{fontWeight: 'bold'}}>{t("project.lineup.person_title") + " " + (index + 2)}</p>
                                        {dynamicMusicianFields[index + 1]}
                                    </div>
                                )}
                            </div>
                        </div>
                    );
                }
                return result;
                }, [])
            }
        </>)}
    </>)
}

export default OthersList

